export const UPDATE_REASON = "UPDATE_REASON";
export const UPDATE_REASON_PENDING = "UPDATE_REASON_PENDING";
export const UPDATE_REASON_REJECTED = "UPDATE_REASON_REJECTED";
export const UPDATE_REASON_FULFILLED = "UPDATE_REASON_FULFILLED";

export const CLEAR_REASONS = "CLEAR_REASONS";
